import { KSendSuccessResponse } from '@asset-metrix/portal-gateway-client-js';
import { MutationFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const createFopiTableRow: MutationFunction<
  KSendSuccessResponse,
  {
    contentId: string;
    data: Record<string, unknown>;
    files: File[];
  }
> = async ({ contentId, data, files }) => {
  const response = await portalGatewayClient.fopi.createFopiTableRow(
    contentId,
    { data, files }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error creating fopi row'),
      response
    );
  }

  return response.data;
};
